<template>
  <div id='app' class="fc fc-3">
    <router-view/>
  </div>
</template>

<script>
import { utils } from 'frontendcommon-3'
import { useCommonAuth } from './store'
import { storeToRefs } from 'pinia'
const { softColor, darkenColor } = utils.ColorUtils
const STYLE_CUSTOMIZATION_ID = 'style-customization'

export default {
  setup () {
    const commonAuthStore = useCommonAuth()
    const { customization } = storeToRefs(commonAuthStore)
    return { customization }
  },
  watch: {
    customization: 'applyCustomization'
  },
  mounted () {
    this.applyCustomization(this.customization)
  },
  methods: {
    injectCustomCss (customization, id = STYLE_CUSTOMIZATION_ID) {
      const oldStyle = document.getElementById(id)
      if (oldStyle) document.head.removeChild(oldStyle)
      const style = document.createElement('style')
      style.id = id
      style.appendChild(document.createTextNode(customization))
      document.head.appendChild(style)
    },
    applyCustomization (customization) {
      const primaryColor = customization?.primary_color ?? '#00B0B9'
      this.injectCustomCss(`
        :root {
          --fc-brand-01: ${primaryColor};
          --fc-brand-01-soft: ${softColor(primaryColor, 10)};
          --fc-brand-01-medium: ${softColor(primaryColor, 50)};
          --fc-brand-01-dark: ${softColor(primaryColor, 70)};
          --fc-brand-01-hover: ${darkenColor(primaryColor, 90)};
          --fc-brand-01-active: ${darkenColor(primaryColor, 80)};
          --fc-brand-02: ${primaryColor};
          --fc-brand-02-soft: ${softColor(primaryColor, 10)};
          --fc-brand-02-medium: ${softColor(primaryColor, 50)};
          --fc-brand-02-dark: ${softColor(primaryColor, 70)};
          --fc-brand-02-hover: ${darkenColor(primaryColor, 90)};
          --fc-brand-02-active: ${darkenColor(primaryColor, 80)};
          --fc-btn-hover: ${softColor(primaryColor, 80)};
        }`
      )
    }
  }
}
</script>

<style lang="scss">
@import "frontendcommon-3/src/scss/config";
.fc-3 .font-default.font-default {
  @include default();
}
.text-separator {
  font-size: 12px;
  line-height: 18px;
  display: flex;
  align-items: center;
  text-align: center;
  color: $medium-grey;
  &::before {
    content: '';
    border-bottom: 1px solid $border-color;
    margin-right: 6px;
    flex: 1 1 auto;
  }
  &::after {
    content: '';
    border-bottom: 1px solid $border-color;
    margin-left: 6px;
    flex: 1 1 auto;
  }
}

// Fix input labels (REMOVE IF use frontendcommon-3@ds-chnages-3 in project)
.inputbox-container.has-focus:not(.is-readonly) > label,
.inputbox-container.has-value > label,
.inputbox-container.no-label-transition > label {
  font-size: 12px !important;
}
</style>
